var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56117",
    "data-name": "Group 56117",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.065,
    height: 93.727,
    viewBox: "0 0 148.065 93.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135461",
    "data-name": "Path 135461",
    d: "M85.154,53.652l1.78,10.2-9.491-4.864-9.491,4.864,1.78-10.2L61.9,46.3l10.8-1.542L77.442,35.5l4.746,9.254,10.8,1.542Z",
    transform: "translate(-3.41 -35.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135462",
    "data-name": "Path 135462",
    d: "M120.054,68.034l1.78,10.2-9.491-4.746-9.491,4.746,1.78-10.2L96.8,60.678l10.8-1.542L112.342,50l4.746,9.135,10.8,1.542Z",
    transform: "translate(3.096 -32.797)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135463",
    "data-name": "Path 135463",
    d: "M134.435,101.434l1.9,10.2-9.61-4.746-9.491,4.746,1.78-10.2L111.3,94.078l10.8-1.424,4.627-9.254,4.746,9.254,10.8,1.424Z",
    transform: "translate(5.799 -26.571)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135464",
    "data-name": "Path 135464",
    d: "M35.854,101.434l1.78,10.2-9.491-4.746-9.61,4.746,1.9-10.2L12.6,94.078l10.8-1.424L28.142,83.4l4.627,9.254,10.8,1.424Z",
    transform: "translate(-12.6 -26.571)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135465",
    "data-name": "Path 135465",
    d: "M50.254,68.034l1.78,10.2-9.491-4.746-9.491,4.746,1.78-10.2L27,60.678l10.8-1.542L42.542,50l4.746,9.135,10.8,1.542Z",
    transform: "translate(-9.916 -32.797)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135466",
    "data-name": "Path 135466",
    d: "M89.14,82.339A12.221,12.221,0,1,1,76.92,70,12.3,12.3,0,0,1,89.14,82.339Z",
    transform: "translate(-2.888 -29.069)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135467",
    "data-name": "Path 135467",
    d: "M104.379,118.154H53.6a25.487,25.487,0,0,1,50.779,0Z",
    transform: "translate(-4.957 -24.427)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonals);
export default __webpack_public_path__ + "static/media/testimonals.0b0ec390254590485ac187eb1669d913.svg";
export { ForwardRef as ReactComponent };